import { render } from "./WalletView.vue?vue&type=template&id=214ca1f9&scoped=true&ts=true"
import script from "./WalletView.vue?vue&type=script&lang=ts"
export * from "./WalletView.vue?vue&type=script&lang=ts"

import "./WalletView.vue?vue&type=style&index=0&id=214ca1f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214ca1f9"]])

export default __exports__